"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const appbrand01 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 46 70",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-appbrand01` : '') + (description ? ` desc-appbrand01` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-appbrand01"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-appbrand01"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.939 44.466v-30.97a8.693 8.693 0 0 1 8.693-8.693h21.732c4.801 0 8.693 3.892 8.693 8.693v47.811A8.693 8.693 0 0 1 36.364 70H14.632a8.693 8.693 0 0 1-8.693-8.693v-1.449",
    fill: "#FFC599",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.693 2A7.693 7.693 0 0 0 2 9.693v42.465h37.118V9.692A7.693 7.693 0 0 0 31.425 2H9.693Zm31.425 7.693C41.118 4.34 36.778 0 31.425 0H9.693C4.34 0 0 4.34 0 9.693v47.81c0 5.354 4.34 9.694 9.693 9.694h21.732c5.353 0 9.693-4.34 9.693-9.693V9.693Zm-2 44.465H2v3.346a7.693 7.693 0 0 0 7.693 7.693h21.732a7.693 7.693 0 0 0 7.693-7.693v-3.346Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fill: "#F26B1C"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.16 39.08H13l-.157-.008c-1.094-.1-2.032-.95-2.23-2.093l-2.18-15.316c-.046-.794.217-1.484.715-1.985a2.467 2.467 0 0 1 1.899-.723l19.63-.002c.646-.041 1.337.222 1.837.725.499.501.76 1.191.722 1.898L31.054 36.95c-.213 1.226-1.232 2.102-2.427 2.131H13.159Zm15.384-2a.526.526 0 0 0 .534-.443l2.17-15.256a.535.535 0 0 0-.151-.292.465.465 0 0 0-.36-.138l-19.751.002c-.194-.01-.325.04-.42.136a.499.499 0 0 0-.144.38l2.166 15.199a.52.52 0 0 0 .53.412h15.426Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.816 15.213c2.44.007 4.53 1.758 4.987 4.172a1 1 0 1 1-1.965.372c-.28-1.475-1.55-2.54-3.02-2.544-1.47.006-2.735 1.062-3.02 2.528a1 1 0 1 1-1.963-.382 5.104 5.104 0 0 1 4.981-4.146ZM23.608 25l-.209.007a3.057 3.057 0 0 0-2.014.955l-.555.579-.559-.585a3.051 3.051 0 0 0-4.44.005 3.28 3.28 0 0 0 0 4.499l3.823 3.992a1.62 1.62 0 0 0 2.36-.005l3.813-3.983a3.284 3.284 0 0 0 .005-4.503A3.055 3.055 0 0 0 23.608 25Zm0 2c.29 0 .567.12.769.333l.092.11c.367.49.337 1.189-.092 1.644l-3.547 3.702-3.55-3.708a1.279 1.279 0 0 1 .005-1.747c.201-.214.479-.334.768-.334.29 0 .567.12.768.334l1.287 1.344a1 1 0 0 0 1.445 0l1.282-1.34c.206-.218.484-.338.773-.338Z"
  })));
};
var _default = exports.default = appbrand01;